import React, {useState, useEffect, useRef, useMemo} from 'react';
import {useNavigate} from 'react-router-dom';
import styled from 'styled-components';
import LS from '../styles/layoutStyled'
import CS from '../styles/componentStyled'
import AlarmModal3 from '../modal/AlarmModal3';
import MembershipCardModal from '../modal/MembershipCardModal';
import { ApiService } from '../api';
import { useRecoilState, useSetRecoilState, useRecoilValue } from 'recoil';
import { accessTokenState, refreshTokenState, expireState } from '../atom/TokenAtom';
import { alarmModal1Text } from '../atom/ModalAtom';
import { Config } from '../config';
import MemberExcelModal from '../modal/MemberExcelModal';
import Pagenation from '../component/Pagenation';

const Member = () => {
    const apiService = new ApiService();
    const navigate = useNavigate();
    const setAlarm1Text = useSetRecoilState(alarmModal1Text);

    const [offset, setOffset] = useState(0);
    const [limit, setLimit] = useState(10);
    const [listLength, setListLength] = useState<number>(0);
    const [resetTrigger, setResetTrigger] = useState(false);

    // 토큰
    const [accessToken, setAccessToken] = useRecoilState(accessTokenState)
    const [refreshToken, setRefreshToken] = useRecoilState(refreshTokenState);
    const [expire, setExpire] = useRecoilState(expireState);

    // 회원증 모달
    const [isMembershipCardModal, setIsMembershipCardModal] = useState(false);
    const closeMembershipCardModal = () => {
        setIsMembershipCardModal(false);
    }

    // 회원증 모달 props
    const [mode, setMode] = useState('');

    // 회원증 수정 객체
    const [modifyItem, setModifyItem] = useState('');

    // oo개씩 보기
    const handleViewNumChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setLimit(parseInt(e.target.value));
        setCheckItems([]);
        setOffset(0);
    }

    const [members, setMembers] = useState<any[]>([]);

    // 회원증 목록
    const fetchMemberList: any = async (searchOffset?: number) => {
        if (searchOffset !== undefined) {
            setOffset(searchOffset);
        }
        try {
            if (!accessToken) return;
            const MemberList = await apiService.associationList(accessToken, name, userNumber, phoneNumber, belong, memberLevel, offset, limit);
            setMembers(MemberList);
        }
        catch(err: any) {
            localStorage.clear();
            navigate('/login');
        }
    };

    const fetchAllMemberList: any = async (searchOffset?: number) => {
        if (searchOffset !== undefined) {
            setOffset(searchOffset);
        }
        try {
            if (!accessToken) return;
            const MemberList = await apiService.associationList(accessToken, name, userNumber, phoneNumber, belong, memberLevel);
            setListLength(MemberList.length);
        }
        catch(err: any) {
            localStorage.clear();
            navigate('/login');
        }
    };

    useEffect(() => {
        fetchMemberList();
        fetchAllMemberList();
    }, [offset, limit, resetTrigger]);

    // 이름
    const [name, setName] = useState('');
    const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setName(value);
    };

    // 회원 번호
    const [userNumber, setUserNumber] = useState('');
    const handleUserNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setUserNumber(value);
    };

    // 휴대폰 번호
    const [phoneNumber, setPhoneNumber] = useState('');
    const handlePhoneNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setPhoneNumber(value);
    };

    // 소속
    const [belong, setBelong] = useState('');
    const handleBelongChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        setBelong(value);
    };

    // 회원 구분
    const memberLevelRef = useRef<HTMLSelectElement>(null);
    const [memberLevel, setMemberLevel] = useState<string>('');
    const handleMemberLevelChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        setMemberLevel(e.target.value);
        memberLevelRef.current?.classList.add("selected");
        if (e.target.value === '') {
            memberLevelRef.current?.classList.remove("selected");
        }
    };

    const handleSearchReset = () => {
        setOffset(0);
        setLimit(10);
        setName('');
        setUserNumber('');
        setPhoneNumber('');
        setBelong('');
        setMemberLevel('');
        memberLevelRef.current?.classList.remove("selected");
        setResetTrigger(!resetTrigger);
    }

    // 아이템 선택
    const [checkItems, setCheckItems] = useState<number[]>([]);
    const handleSingleCheck = (checked: boolean, id: number) => {
        if (checked) {
            setCheckItems(prev => [...prev, id]);
        }
        else {
            setCheckItems(prev => prev.filter((el) => el !== id));
        }
    }
    const handleAllCheck = (checked: boolean) => {
        if (checked) {
            const idArray: number[] = [];
            members.forEach((el) => idArray.push(el.id));
            setCheckItems(idArray);
        }
        else {
            setCheckItems([]);
        }
    }

    // 선택 삭제 버튼 클릭시
    const [isDelConfirmModal, setIsDelConfirmModal] = useState(false);
    const openDelConfirmModal = () => {
        if (checkItems.length === 0) {
            setAlarm1Text("선택된 항목이 없습니다.");
            return;
        }
        setIsDelConfirmModal(true);
    }
    const closeDelConfirmModal = () => {
        setIsDelConfirmModal(false);
    }
    const handleConfirm: any = async () => {
        if (!accessToken) return;
        await apiService.delAssociation(accessToken, checkItems);
        window.location.reload();
    }

    // 엑셀 등록
    const [isMemberExcelModal, setIsMemberExcelModal] = useState(false);
    const closeMemberExcelModal = () => {
        setIsMemberExcelModal(false);
    }

    const handleOffsetChange = (value: number) => {
        setOffset((value - 1) * limit);
        setCheckItems([]);
    }

    return (
        <>
            <h1>건축물 안전 협회 회원증</h1>

            <CS.SearchOptionBox>
                <div className="search-area">
                    <ul>
                        <li>
                            <h3>이름</h3>
                            <div className="input-area">
                                <CS.TextInputType1
                                    type="text"
                                    placeholder="이름"
                                    value={name}
                                    onChange={handleNameChange}
                                />
                            </div>
                        </li>
                        <li>
                            <h3>회원 번호</h3>
                            <div className="input-area">
                                <CS.TextInputType1
                                    type="text"
                                    placeholder="회원 번호"
                                    value={userNumber}
                                    onChange={handleUserNumberChange}
                                />
                            </div>
                        </li>
                        <li>
                            <h3>휴대폰 번호</h3>
                            <div className="input-area">
                                <CS.TextInputType1
                                    type="text"
                                    placeholder="휴대폰 번호(-자 제외)"
                                    value={phoneNumber}
                                    onChange={handlePhoneNumberChange}
                                />
                            </div>
                        </li>
                        <li>
                            <h3>소속</h3>
                            <div className="input-area">
                                <CS.TextInputType1
                                    type="text"
                                    placeholder="소속"
                                    value={belong}
                                    onChange={handleBelongChange}
                                />
                            </div>
                        </li>
                        <li>
                            <h3>회원 구분</h3>
                            <CS.SelectType1>
                                <select
                                    value={memberLevel}
                                    onChange={handleMemberLevelChange}
                                    ref={memberLevelRef}
                                >
                                    <option value="" style={{ color: '#999' }}>회원 구분</option>
                                    <option value='Irregular'>준회원</option>
                                    <option value='Regular'>정회원</option>
                                </select>
                                <span className='img-box'>
                                    <img src="./img/arrow_bottom_898989.svg" alt="" />
                                </span>
                            </CS.SelectType1>
                        </li>
                    </ul>
                </div>
                <div className="btn-box flex aic jcc">
                    <CS.Btn3Type1 onClick={() => {
                        fetchMemberList(0);
                        fetchAllMemberList(0);
                    }}>검색</CS.Btn3Type1>
                    <CS.Btn3Type2 onClick={handleSearchReset}>초기화</CS.Btn3Type2>
                </div>
            </CS.SearchOptionBox>

            <CS.TableOptionBox>
                <div className="all-text-box">
                    전체 <span>{listLength}</span>개
                </div>
                <div className="btn-option-box">
                    <CS.SelectType1 style={{ width: 130 }}>
                        <select
                            value={limit}
                            onChange={handleViewNumChange}
                            className='selected'
                        >
                            <option value={10}>10개씩 보기</option>
                            <option value={20}>20개씩 보기</option>
                            <option value={30}>30개씩 보기</option>
                            <option value={50}>50개씩 보기</option>
                        </select>
                        <span className='img-box'>
                            <img src="./img/arrow_bottom_898989.svg" alt="" />
                        </span>
                    </CS.SelectType1>
                    <CS.Btn3Type3 onClick={openDelConfirmModal}>선택 삭제</CS.Btn3Type3>
                    <CS.Btn3Type4 onClick={() => setIsMemberExcelModal(true)}>Excel 등록</CS.Btn3Type4>
                    <CS.Btn3Type2 
                        onClick={() => {
                            setIsMembershipCardModal(true);
                            setMode('add');
                            setModifyItem('');
                        }}
                    >등록</CS.Btn3Type2>
                </div>
            </CS.TableOptionBox>

            <CS.TableType1>
                <table>
                    <thead>
                        <tr>
                            <th>
                                <CS.CheckBoxType1>
                                    <input
                                        type="checkbox"
                                        id="all"
                                        onChange={(e) => handleAllCheck(e.target.checked)}
                                        checked={
                                            members.length === 0
                                            ? false : checkItems.length === (members.length < limit ? members.length : limit) ? true : false
                                        }
                                    />
                                    <label htmlFor="all"></label>
                                </CS.CheckBoxType1>
                            </th>
                            <th>No</th>
                            <th>회원 번호</th>
                            <th>이름</th>
                            <th>소속</th>
                            <th>휴대폰 번호</th>
                            <th>발급일자</th>
                            <th>유효기간</th>
                            <th>상태</th>
                            <th>신분</th>
                        </tr>
                    </thead>
                    <tbody>
                        {members.map((member, index) => (
                            <tr key={index}>
                                <td>
                                    <CS.CheckBoxType1>
                                        <input
                                            type="checkbox"
                                            id={`cv-${index}`}
                                            onChange={(e) => handleSingleCheck(e.target.checked, member.id)}
                                            checked={checkItems.includes(member.id) ? true : false}
                                        />
                                        <label htmlFor={`cv-${index}`}></label>
                                    </CS.CheckBoxType1>
                                </td>
                                <td>{(offset + index + 1).toLocaleString()}</td>
                                <td>
                                    <button
                                        className='modify-btn'
                                        onClick={() => {
                                            if (member.position !== 'Regular') {
                                                setAlarm1Text("준회원은 수정할 수 없습니다.");
                                                return;
                                            }
                                            setIsMembershipCardModal(true);
                                            setMode('');
                                            setModifyItem(member);
                                        }}
                                    >
                                        {member.membership_number}
                                    </button>
                                </td>
                                <td>{member.name}</td>
                                <td>{member.association_name === '' ? 'N/A' : member.association_name}</td>
                                <td>{member.phone_number}</td>
                                <td>{new Date(member.created_at).toLocaleDateString()}</td>
                                <td>{new Date(member.exp_date).toLocaleDateString()}</td>
                                {new Date(member.exp_date) < new Date() && (
                                    <td className='expiration'>만료</td>
                                )}
                                {new Date(member.exp_date) >= new Date() && (
                                    <td className='normal'>정상</td>
                                )}
                                <td>{member.position === 'Regular' ? '정회원' : '준회원'}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </CS.TableType1>

            {listLength !== 0 &&
                <Pagenation
                    listAllLength={listLength}
                    listLimit={limit}
                    onCurrentPageChange={handleOffsetChange}
                />
            }

            {isMembershipCardModal && (
                <MembershipCardModal
                    mode={mode}
                    onClose={closeMembershipCardModal}
                    modifyItem={modifyItem}
                />
            )}

            {isMemberExcelModal && (
                <MemberExcelModal
                    onClose={closeMemberExcelModal}
                />
            )}

            {isDelConfirmModal && (
                <AlarmModal3
                    modalType='del'
                    onClose={closeDelConfirmModal}
                    onConfirm={handleConfirm}
                />
            )}
        </>
    );
};

export default Member;